import React, { Component } from 'react';
import { isMobileOnly } from "react-device-detect";

import { NavigationActions } from '../../actions';
import '../../css/common/SingleScreenNavBar.css';

class SingleScreenNavBar extends Component {

  render() {
    let title        = this.props.title || '';
    let margin_right = isMobileOnly ? 10 : 0;
    return (
      <div className="flex-container single-screen-nav-bar-container">
        <div className="single-screen-nav-bar-left-container flex-container flex-container-column flex-center-align flex-center-justify">
          <div style={{ paddingLeft: 40, marginRight: margin_right }}>
            <span className="fas fa-arrow-circle-left single-screen-nav-bar-back-button"
                  onClick={ () => { NavigationActions.navigateBack() }}></span>
          </div>
        </div>
        <div className="flex-container single-screen-nav-bar-title-container">
          <span style={{ color: '#575757', fontSize: 16 }}>{ title }</span>
        </div>
        <div className="single-screen-nav-bar-right-container"></div>
      </div>
    );
  }

}

export default SingleScreenNavBar
